module.exports = __webpack_public_path__ + "static/media/noDBExtra.ff0b9a71.jpg";